import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const User: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 470c-39.93 0-77.68-16.47-106.3-46.38-27.77-29.03-43.7-68.41-43.7-108.04 0-82.71 67.29-150 150-150s150 67.29 150 150c0 39.63-15.93 79.01-43.7 108.04-28.62 29.91-66.37 46.38-106.3 46.38zm0-274.43c-66.17 0-120 53.83-120 120s54.95 124.43 120 124.43 120-56.98 120-124.43-53.83-120-120-120z' />
    <path d='m630 615h-30c0-37.75-21.16-73.58-59.59-100.91-39.98-28.43-93.4-44.09-150.41-44.09s-110.43 15.66-150.41 44.09c-38.43 27.33-59.59 63.17-59.59 100.91h-30c0-47.73 25.64-92.25 72.21-125.36 45.01-32.01 104.6-49.64 167.79-49.64s122.78 17.63 167.79 49.64c46.56 33.11 72.21 77.63 72.21 125.36z' />
  </IconBase>
));

User.displayName = 'User';

export default User;
